exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-row[data-v-0e4fd399] {\n  margin-bottom: 20px;\n}\n.el-row[data-v-0e4fd399]:last-child {\n    margin-bottom: 0;\n}\n.el-col[data-v-0e4fd399] {\n  border-radius: 4px;\n}\n.bg-purple-dark[data-v-0e4fd399] {\n  background: #99a9bf;\n}\n.bg-purple[data-v-0e4fd399] {\n  background: #d3dce6;\n}\n.bg-purple-light[data-v-0e4fd399] {\n  background: #e5e9f2;\n}\n.grid-content[data-v-0e4fd399] {\n  border-radius: 4px;\n  min-height: 10px;\n}\n.row-bg[data-v-0e4fd399] {\n  padding: 10px 0;\n  background-color: #f9fafc;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0e4fd399","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/shop/storelist.vue
// module id = 1212
// module chunks = 0